import { MutationTree } from 'vuex';
import { ManageGroup } from '@/interface/store/manageGroups';
import { initialState } from '@/store/modules/manageGroup/index';

export const mutations: MutationTree<ManageGroup> = {
  GET_GROUPS(state, payload) {
    state.fkUserMemberships = payload.fkUserMemberships;
  },
  SET_ME(state, payload) {
    state.meData = payload;
  },
  GET_MEMBERS(state, payload) {
    state.memberList = payload;
  },
  GET_MAIN_LOCATIONS(state, payload) {
    state.mainLocationList = payload.data;
  },
  GET_SUB_LOCATIONS(state, payload) {
    state.subLocationList = payload.data;
  },
  GET_SUB_LOCATION_NAME(state, payload) {
    state.subLocationName = payload.name;
  },
  GET_TYPES(state, payload) {
    state.typeList = payload.data;
  },
  GET_TYPE_FIELDS(state, payload) {
    state.typeFieldList = payload.data;
  },
  GET_TYPE_FIELD_ITEM(state, payload) {
    state.typeFieldItem = payload;
  },
  GET_VENDORS(state, payload) {
    state.vendorList = payload.data;
  },
  GET_VENDOR_ITEM(state, payload) {
    state.vendorItem = payload;
  },
  GET_MANUFACTURERS(state, payload) {
    state.manufacturerList = payload.data;
  },
  GET_MANUFACTURER_ITEM(state, payload) {
    state.manufacturerItem = payload;
  },
  GET_ADDRESSES(state, payload) {
    state.addressList = payload.data;
  },
  GET_ADDRESS_ITEM(state, payload) {
    state.addressItem = payload;
  },
  GET_GRANTS(state, payload) {
    state.grantList = payload.data;
  },
  GET_GRANT_ITEM(state, payload) {
    state.grantItem = payload;
  },
  GET_SETTINGS(state, payload) {
    state.settings = payload;
  },
  RESET_ALL(state) {
    const initialInventoryState = initialState();
    Object.keys(initialInventoryState).forEach((key: any) => {
      (state as any)[key] = (initialInventoryState as any)[key];
    });
  },
};
